/**
 * 公共方法
 */
/**
 * 设置title
 * @param {String} title
 */
export const changeTitle = (title) => {
  document.title = title;
  const iframe = document.createElement("iframe");
  iframe.src = "/changetitle";
  document.body.appendChild(iframe);
  iframe.width = 0;
  iframe.height = 0;
  iframe.remove();
};

// 获取 cookie 参数
export const getCookie = (cname) => {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
};

/*
 * @desc 获取时间戳
 * @returns {string}
 * @private
 */
export function getTime() {
  const d = new Date();
  let format = "yyyyMMddhhmmss";

  const o = {
    "M+": d.getMonth() + 1,
    "d+": d.getDate(),
    "h+": d.getHours(),
    "m+": d.getMinutes(),
    "s+": d.getSeconds(),
  };

  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      `${d.getFullYear()}`.substr(4 - RegExp.$1.length)
    );
    Object.keys(o).forEach((k) => {
      if (new RegExp(`(${k})`).test(format)) {
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
        );
      }
    });
  }

  return format;
}

export function formatNumber(value, toFixed = 1) {
  // 检查 value 是否为 undefined 或 null
  if (typeof value === "undefined" || value === null) {
    return { value: 0, unit: "" };
  }
  if (value >= 10000) {
    const factor = Math.pow(10, toFixed);
    const num = Math.floor((value / 10000) * factor) / factor;
    return {
      value: num,
      unit: "万",
    };
  } else {
    return {
      value: value == 0 && value ? "0" : value.toString(),
      unit: "",
    };
  }
}

/**
 * desc 生成 uuid4
 * @returns {string}
 * @private
 */
/* eslint-disable no-bitwise */
export function genUUID4() {
  const r = Math.random;
  const p = "0000000";
  const n = 0x100000000;
  let a = ((r() * n) >>> 0).toString(16);
  let b = ((((r() * n) & 0xffff4fff) | 0x4000) >>> 0).toString(16);
  let c = ((((r() * n) & 0xbfffffff) | 0x80000000) >>> 0).toString(16);
  let d = ((r() * n) >>> 0).toString(16);

  if (a.length < 8) {
    a = (p + a).slice(-8);
  }
  if (b.length < 8) {
    b = (p + b).slice(-8);
  }
  if (c.length < 8) {
    c = (p + c).slice(-8);
  }
  if (d.length < 8) {
    d = (p + d).slice(-8);
  }

  return [a, b.slice(0, 4), b.slice(4), c.slice(0, 4), c.slice(4) + d].join(
    "-"
  );
}

/*
 * @desc 获取时间戳
 * @returns {format} : 2025.09.09 周二 19:20
 * @returns {format = YYYY.MM.DD HH:mm} : 2025年09月09日 19:20
 * @private
 */
export function formatDate(inputDate, format) {
  // 解析输入日期
  const date = new Date(inputDate);

  // 检查日期是否有效
  if (isNaN(date.getTime())) {
    throw new Error("Invalid date format");
  }

  // 格式化日期部分（YYYY.MM.DD）
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  // 格式化星期部分（周二）
  const weekdays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
  const weekday = weekdays[date.getDay()];

  // 格式化时间部分（HH:MM）
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  // 拼接最终结果
  if (format === "weekday") {
    return `${year}.${month}.${day} ${weekday} ${hours}:${minutes}`;
  }
  if (format === "point") {
    return `${year}.${month}.${day} ${hours}:${minutes}`;
  }
  if (format === "yymmdd") {
    return `${year}.${month}.${day}`;
  }
  if (format === "hhmm") {
    return `${hours}:${minutes}`;
  }
  if (format === "mmddhhmm") {
    return {
      month,
      day,
      hours,
      minutes,
    };
  }
  return `${year}年${month}月${day}日 ${hours}:${minutes}`;
}

export function transforPraiseNum(number) {
  if (!number) {
    return "";
  }
  if (isNaN(Math.ceil(number))) {
    return number;
  }
  number = parseInt(number);
  if (number < 10000) {
    return number;
  }
  const wan = Math.floor(number / 1000);
  return `${wan / 10}万`;
}
